module.exports = __webpack_public_path__ + "img/info.06dc8101.svg";